/** localStorage keys written on login / theming that must be cleared on logout. */
export const AUTH_STORAGE_KEYS = [
  "isLogin",
  "Authorization",
  "accessToken",
  "adminType",
  "primaryColor",
  "secondaryColor",
  "sidebarColor",
  "topbarColor",
  "menuHighlightColor",
  "menuTextColor",
  "accentColor"
];

export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach(key => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // ignore quota / private mode errors
    }
  });
}
